import * as actionTypes from './actionTypes';
import { pricePackageService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { PaymentPriceModel } from '@app/src/views/StepPayment/formPayment/models/PaymentPriceModel';
import { hydrateData } from './hydrators';
import { fetchValidate } from '@app/src/common/session';

const fetchPricePackageRequest = () => ({
  type: actionTypes.FETCH_PRICE_PACKAGE_REQUEST
});

const fetchPricePackageFailure = () => ({
  type: actionTypes.FETCH_PRICE_PACKAGE_FAILURE
});

const fetchPricePackageSuccess = (data: PaymentPriceModel) => ({
  type: actionTypes.FETCH_PRICE_PACKAGE_SUCCESS,
  data
});

const formatData = (data) => data.data && data.data.length > 0 ? hydrateData(data.data[0]) : {};

export const fetchPricePackage = (categoryId: number, summaryId: string) => {
  return async dispatch => {
    dispatch(fetchPricePackageRequest());
    await dispatch(fetchValidate());
    try {
      const data = await pricePackageService.get(categoryId, summaryId);
      if (data.error) {
        dispatch(actionsModalError.openModalError(data.data[0].message, data.data[0].redirect));
      } else {
        dispatch(fetchPricePackageSuccess(formatData(data)));
      }
    } catch(error) {
      dispatch(actionsModalError.openModalError());
      dispatch(fetchPricePackageFailure());
    }
  }
}
